import React from 'react';
import PropTypes from 'prop-types';
import { Droppable } from 'react-beautiful-dnd';
import {
  withContext,
} from '../../../components';
import BenefitTable, { BenefitTh } from './BenefitTable';
import CategoryLayoutButtons from './benefitCategory/CategoryLayoutButtons';
import SubCategoryMarkup from './benefitCategory/SubCategoryMarkup';
import BenefitMarkup from './benefitCategory/BenefitMarkup';
import { Consumer } from '../Context';

const propTypes = {
  context: PropTypes.shape({
    categoryBenefits: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      value: PropTypes.string,
      category: PropTypes.string,
      subcategory: PropTypes.string,
    })),
    categoryName: PropTypes.string,
    editAllowed: PropTypes.bool,
    editBenefitValue: PropTypes.shape({
      BenefitId: PropTypes.number,
    }),
    editSubCategoryName: PropTypes.shape({
      value: PropTypes.string,
      categoryName: PropTypes.string,
    }),
    editBenefitName: PropTypes.shape({
      value: PropTypes.string,
      categoryName: PropTypes.string,
    }),
    enableReorder: PropTypes.bool.isRequired,
    onStartEdit: PropTypes.func.isRequired,
    onSaveEdit: PropTypes.func.isRequired,
    onAddBenefit: PropTypes.func.isRequired,
    onCancelEdit: PropTypes.func.isRequired,
    width: PropTypes.string,
    addBenefit: PropTypes.shape({
      category: PropTypes.string,
      subCategoryName: PropTypes.string,
      planBenefitName: PropTypes.string,
    }),
    onAddRow: PropTypes.func.isRequired,
    onAddColumn: PropTypes.func.isRequired,
    onReset: PropTypes.func.isRequired,
  }),
};

const defaultProps = {
  context: {
    categoryName: null,
    categoryBenefits: null,
    editAllowed: false,
    editBenefitValue: null,
    editSubCategoryName: null,
    editBenefitName: null,
    width: '100%',
    addBenefit: null,
  },
};

function BenefitCategory(props) {
  const {
    context: {
      editAllowed,
      enableReorder,
      width,
      categoryName,
    },
  } = props;

  const nameColumnWidth = width === '100%' ? 30 : 50; // Percentage
  return (
    <Droppable
      droppableId={`droppable-${categoryName}`}
      type={categoryName}
      isDropDisabled={!editAllowed || !enableReorder}
    >
      {provided => (
        <>
          <BenefitTable
            width={width}
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
          >
            <Droppable
              droppableId={`subCategory ${categoryName}`}
              type="subcategory"
              isDropDisabled={!editAllowed || !enableReorder}
              direction="horizontal"
            >
              {providedInner => (
                <thead
                  ref={providedInner.innerRef}
                  {...providedInner.draggableProps}
                  {...providedInner.dragHandleProps}
                >
                  <tr>
                    <BenefitTh scope="col" columnWidth={`${nameColumnWidth}%`} />
                    <SubCategoryMarkup />
                    {providedInner.placeholder}
                  </tr>
                </thead>
              )}
            </Droppable>
            <tbody>
              <BenefitMarkup />
              {provided.placeholder}
            </tbody>
          </BenefitTable>
          {editAllowed && (
          <CategoryLayoutButtons />
          )}
        </>
      )}
    </Droppable>
  );
}

BenefitCategory.defaultProps = defaultProps;
BenefitCategory.propTypes = propTypes;
export default withContext(Consumer)(BenefitCategory);
